import React from 'react'

import Tabs from '@organisms/Tabs'
import Modal from '@molecules/Modal'
import Heading from '@atoms/Heading'
// import Button from '@atoms/Button'
import BtBottom from '@atoms/Button/img/arrow-bottom.svg'
import NousConnaitre4 from '@img/icons/nous_connaitre_4.svg'
import Gouvernance from './img/Gouvernance/gouvernance.png'
import Organigramme from './img/Gouvernance/organigramme.svg'

import '@templates/nousconnaitre.scss'
import Paragraph from '@atoms/Paragraph'
const Content = () => {
	return (
		<>
			<div className="row " style={{ alignItems: 'flex-end' }}>
				<div className="col offset-2" style={{ width: 'auto' }}>
					<img
						className="responsive-image img_nb"
						style={{ maxWidth: '155px' }}
						src={NousConnaitre4}
					/>
				</div>
				<div className="col" style={{ width: 'auto' }}>
					<Heading className="font-size-3" tag="h3">
						orientations
						<br />
						stratégiques
						<br /> de l'entreprise
					</Heading>
				</div>
			</div>
			<div className="row  ">
				<div className="col offset-2 col-4">
					<div className="list">
						<Heading tag="h4">
							Améliorer<span>la qualité de notre gestion locative</span>
							Accompagner<span>les locataires</span>
						</Heading>
						<Heading tag="h4">
							Contribuer<span>à une ville accessible à tous</span>
						</Heading>
						<Heading tag="h4">
							Lutter<span>contre le réchauffement climatique</span>
							S’adapter<span>à ses conséquences</span>
						</Heading>
						<Heading tag="h4">
							Prendre notre part
							<span>
								en tant qu’acteur de la Ville et de la vie sociale, culturelle
								et économique
							</span>
						</Heading>
						<Heading tag="h4">
							Développer
							<span>notre capital humain</span>
							Améliorer
							<span>notre performance</span>
						</Heading>
					</div>

					<a
						className="bt_next_modal mt-sx-5 cursor_pointer"
						href="#nousConnaitreTabs"
					>
						<img className="responsive-image" src={BtBottom} />
					</a>
				</div>
				<div className="col col-4 text offset-1 mt-xs-15 mt-xl-40">
					<Paragraph>
						<p>
							Elogie-Siemp, 3e bailleur social de la Ville de Paris, gère un
							patrimoine de près de 30 000 logements à Paris et en banlieue, ce
							qui représente environ 70 000 locataires. Elogie-Siemp s’inscrit
							dans le cadre des engagements sociaux, sociétaux et écologiques de
							la Ville de Paris au travers notamment de son propre Plan Climat
							2020-2030-2050, ainsi que de son projet stratégique adopté en
							2021. Celui-ci trace les grandes orientations pour les années à
							venir pour ainsi, <b>Ensemble, Faire la ville de demain</b>.<br />
							Le choix d'une gouvernance resserrée et collective, ainsi que le
							renforcement du maillage territorial et de la présence des
							gardiennes et gardiens auprès des locataires, participent de
							l'atteinte de ces objectifs.
							<br />
							<br />
							Elogie-Siemp gère son patrimoine en veillant à la valorisation du
							patrimoine en s’assurant de l’entretien, de la maintenance et de
							la mise à niveau des équipements comme du bâti tout en s’engageant
							pour un futur neutre en carbone.
						</p>
					</Paragraph>
				</div>
			</div>
		</>
	)
}
const NousConnaitre = () => {
	return (
		<Modal
			showNext
			id="modalNousConnaitre"
			open="<a href='#' class='nav-link'>Nous connaître</a>"
			content={<Content />}
			content_add={
				<Tabs
					id="nousConnaitreTabs"
					currentActiveTabs={0}
					titles={['Gouvernance', 'Organigramme']}
					datas={[
						<img src={Gouvernance} className="responsive-image" />,
						<img src={Organigramme} className="responsive-image organigramme" />
					]}
				/>
			}
		/>
	)
}
export default NousConnaitre
